import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomInput from '../../components/CustomInput/CustomInput';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import ButtonGroupSelect from '../../components/Select/ButtonGroupSelect';
import { LicenseIcon } from "../../variables/dataIcons.jsx";
import Countries from 'assets/countries.json'
import ReactSelect from '../../components/Select/ReactSelect';
import Button from '../../components/CustomButtons/Button';
import Api from '../../api/Api.js';
import LicenseEndpoints from '../../api/LicenseEndpoints';
import LicensePlugins from '../../plugins/License';
import { push } from 'connected-react-router';
import { store } from '../../redux/store';

class AddLicense extends Component {
    constructor(props) {
        super(props);
        this.countryMenuItems = Countries.map(x => { return { label: x.name, value: x.code } })
    }

    countryMenuItems = [];
    tarrifs = [];

    state = {
        type: 'USSD Strings',
        product_reference: '',
        country: { label: 'South Africa', value: 'ZA' },
        loading: false,
        tarrifs: [],
        selectedTarrif: { label: 'None', value: null }
    }

    componentDidMount () {
        Api.get(LicenseEndpoints.tarrifs).then(({ data }) => {
            this.tarrifs = data.map(x => ({ ...x, label: x.name, value: x.id }));
            this.changeTarrifs();
        })
    }

    changeTarrifs() {
        this.setState({ selectedTarrif: { label: 'None', value: null }, tarrifs: this.tarrifs.filter(x => (this.state.type === "USSD Strings" ? x.licensed_service_id == 1 : x.licensed_service_id == 2)) })
    }

    submit() {
        var requestBody = { 
            license_tarrif_id: this.state.selectedTarrif.value, 
            country: this.state.country.value, 
            product_reference: this.state.product_reference, 
            status: 'available',
            ...(this.pluginRef && this.pluginRef.submit())
        };
        switch (this.state.type) {
            case "USSD Strings":
                requestBody.service_id = 18
                requestBody.licensed_service_id = 1
                break;
            case "Short Codes":
                requestBody.service_id = 14
                requestBody.licensed_service_id = 2
                break;
        }

        Api.post(LicenseEndpoints.add, requestBody)
        .then(({ data }) => {            
            this.setState({ loading: false }, () => store.dispatch(push('/license/view/' + data.id))) //TODO: Verify it's working
        })
        .catch((e) => {
            this.setState({ loading: false })
            console.error(e);
        })
    }

    renderPlugin() {
        var PluginComponent = null;
        if(this.state.type === "USSD Strings")
        {
            PluginComponent = LicensePlugins[1].add;
        }
        else if(this.state.type === "Short Codes")
        {
            PluginComponent = LicensePlugins[2].add;
        }
        if(PluginComponent)
            return <PluginComponent ref={pluginRef => this.pluginRef = pluginRef} parentState={this.state} parentProps={this.props} />;
        else 
            return null;
    }

    render() {
        return (
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                    <Card loading={this.state.loading}>
                        <CardBody>
                            <h3><FontAwesomeIcon style={{ marginTop: 4, marginLeft: 4, color: 'goldenrod' }} icon={LicenseIcon} /> Add License</h3>

                            License Type:
                            <div style={{ textAlign: 'center' }}>
                                <ButtonGroupSelect
                                    options={["USSD Strings", "Short Codes"]}
                                    value={this.state.type}
                                    onChange={(val) => this.setState({ type: val }, () => this.changeTarrifs())}
                                />
                            </div>

                            <CustomInput
                                labelText={this.state.type === "USSD Strings" ? "USSD String e.g. *123*4567#" : "Short Code e.g. 12345"}
                                id="reference"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ product_reference: event.target.value }),
                                    value: this.state.product_reference,
                                }}
                            />

                            <ReactSelect
                                label="Country"
                                options={this.countryMenuItems}
                                value={this.state.country}
                                onChange={(value) => this.setState({ country: value })}
                                isSearchable
                            />

                            <ReactSelect
                                label="Tarrif"
                                options={this.state.tarrifs}
                                value={this.state.selectedTarrif}
                                onChange={(value) => this.setState({ selectedTarrif: value })}
                                isSearchable
                            />

                            {this.renderPlugin()}

                            <Button round color="success" style={{ float: 'right' }} onClick={() => {
                                this.setState({ loading: true }, () => this.submit())
                            }}>
                                Add License
                            </Button>

                            
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        );
    }
}

export default AddLicense;